export enum CardTemperatureEnum {
  COLD = "COLD",
  WARM = "WARM",
  HOT = "HOT",
}
